function visualPop(path) {
  $(path).hide().fadeIn('slow');
}

window.visualPop = visualPop;
